import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const servicedeskReports1Route: InvariantJiraRoute = {
	name: 'servicedesk-reports',
	path: '/jira/servicedesk/projects/:projectKey/reports',
	exact: true,
};
